import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { type InquiryForm as FormType } from '../../../models/Inquiry/Inquiry';
import { getForm } from '../../../services/inquiry';

import InquiryForm from '../components/InquiryForm';

export default function UpdateInquiryForm() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<FormType>();

  useEffect(() => {
    const formID = Number(id);

    if (!Number.isNaN(formID)) {
      setIsLoading(true);

      getForm(formID)
        .then((res) => {
          if (res?.data) {
            setData(res.data);
          }
        })
        .catch((err) => {
          console.warn(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [id]);

  if (isLoading) {
    return (
      <div className="spinner-border spinner-border-sm text-primary mt-2" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    );
  }

  if (!isLoading && !data) return null;

  return (
    <InquiryForm
      isLoading={false}
      formID={Number(id)}
      data={data}
    />
  );
}
